import { MSAL_CONFIG } from '@/constants';

/**
 * Parse a JWT token and return its claims
 */
export function parseJwt(token: string): any {
  try {
    if (!token || typeof token !== 'string') {
      console.error('Invalid token provided to parseJwt');
      return {};
    }

    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error(
        'Invalid JWT token format: expected 3 parts separated by dots',
      );
      return {};
    }

    const base64Url = parts[MSAL_CONFIG.JWT.TOKEN_PAYLOAD_INDEX];
    if (!base64Url) {
      console.error('JWT payload part is missing');
      return {};
    }

    // Convert base64url to base64
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    // Add padding if needed
    while (base64.length % 4) {
      base64 += '=';
    }

    // Decode base64 to binary string
    const binaryString = atob(base64);

    // Convert binary string to UTF-8 using TextDecoder (more reliable than manual encoding)
    const bytes = new Uint8Array(binaryString.length);
    for (let index = 0; index < binaryString.length; index++) {
      bytes[index] = binaryString.charCodeAt(index);
    }

    const decoder = new TextDecoder('utf-8');
    const jsonPayload = decoder.decode(bytes);

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error parsing JWT:', error);
    if (error instanceof Error) {
      console.error('Error details:', error.message, error.stack);
    }
    return {};
  }
}
